module.exports = __webpack_public_path__ + "img/dorethea-dix.1cf62c38.png";